import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import SimulationMonitorTable from './table/SimulationMonitorTable';
import SimulationMonitorEditForm from './editform/SimulationMonitorEditForm';

i18next.addResourceBundle('en', 'simulationMonitor', en);
i18next.addResourceBundle('hu', 'simulationMonitor', hu);

export default [
	{
		path: '/simulation-monitor/edit/:id/:tabKey?',
		component: SimulationMonitorEditForm,
		auth: authRoles.simulationMonitor
	},
	{
		path: '/simulation-monitor/:sessionNameParam?',
		component: SimulationMonitorTable,
		auth: authRoles.simulationMonitor
	}
];
